import type { NavItem } from '@typings/content';

export const SITE = {
  name: 'SoftonicHub',
  tagline: 'Software, AI and cloud engineering',
  email: 'hello@softonichub.com',
  description:
    'Engineering, artificial intelligence and cloud infrastructure for teams who intend to ship something that lasts.',
} as const;

/** Primary navigation, in reading order. Home is reached through the logo. */
export const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Services', to: '/services' },
  { label: 'Work', to: '/work' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

/** The one action every page leads towards. */
export const PRIMARY_CTA: NavItem = { label: 'Start a project', to: '/contact' };

/**
 * Where the contact form posts. Read from the environment so the endpoint
 * (a form service now, our own API later) can change without a code change.
 * When unset, the form falls back to composing an email.
 */
export const CONTACT_ENDPOINT: string | undefined = import.meta.env.VITE_CONTACT_ENDPOINT;
